import React from 'react'
import LinkCard from './components/LinkCard'

interface LinkCardsProps {
  title1: string
  link1: string
  external1?: boolean
  title2: string
  link2: string
  external2?: boolean
}

const LinkCards = ({
    title1,
    link1,
    external1 = false,
    title2,
    link2,
    external2 = false,
}: LinkCardsProps) => {
    return (
        <div className='flex items-center grid md:grid-cols-2 border-t border-black/10'>
            <LinkCard
                link={link1}
                title={title1}
                external={external1}
                className='border-b md:border-b-0 md:border-r'
            />
            <LinkCard link={link2} title={title2} external={external2} />
        </div>
    )
}

export default LinkCards
